<div class="service-summary" [class.service-summary--force-column]="forceTrafficBottom()">
  <div class="service-summary__main">
    <div class="service-summary__header">
      <service-title-block
        [firewallEnabled]="showFirewallEnabled()"
        [healthStatus]="health().status"
        [isAccessible]="isAccessible()"
        [service]="titleBlockVm()"
        [tags]="tags()"
        [title]="title()"
      />
    </div>
    <div class="service-summary__table">
      <div class="service-summary__table-row">
        <div class="service-summary__table-col">{{ "ServiceElement.Owner" | translate }}</div>
        <div class="service-summary__table-col">{{ organisationName() }}</div>
      </div>
      <div class="service-summary__table-row">
        <div class="service-summary__table-col">
          <span>{{ (isPort() ? "ServiceElement.PortID" : "ServiceElement.ServiceID") | translate }}</span>
        </div>
        <div class="service-summary__table-col">{{ subscriptionId() | shorten_guid }}</div>
      </div>
      @if (showVlanranges()) {
        <div class="service-summary__table-row">
          <div class="service-summary__table-col">{{ "ServiceElement.VLANID" | translate }}</div>
          <div class="service-summary__table-col">
            @for (row of vlanrangeRows(); track row.vlanrange) {
              <div>
                @if (row.untagged) {
                  <span>{{ "Subscription.UntaggedPort" | translate }}</span>
                } @else {
                  <span>{{ row.vlanrange }}</span>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (service().port?.serviceTag; as serviceTag) {
        <div class="service-summary__table-row">
          <div class="service-summary__table-col">{{ "ServiceElement.ServiceTag" | translate }}</div>
          <div class="service-summary__table-col">{{ serviceTag }}</div>
        </div>
      }
      @if (locations().length > 0) {
        <div class="service-summary__table-row">
          <div class="service-summary__table-col">
            {{ (locations().length === 1 ? "ServiceElement.Location" : "ServiceElement.Locations") | translate }}
          </div>
          <div class="service-summary__table-col service-summary__table-col--flex-newline">
            @for (location of locations(); track location) {
              <span>{{ location }}</span>
            }
          </div>
        </div>
      }
      @if (service().ipGateway; as ipGateway) {
        <div class="service-summary__table-row">
          <div class="service-summary__table-col">{{ "ServiceElement.ServiceSpeed" | translate }}</div>
          <div class="service-summary__table-col">{{ ipGateway.serviceSpeed | service_speed }}</div>
        </div>
      }
    </div>

    @if (showTrafficButton()) {
      <div class="service-summary__bottom">
        <div class="button button--secondary service-summary__scroll-button" (click)="navigateToChart()">
          {{ "Global.ShowTraffic" | translate }}
        </div>
      </div>
    }
  </div>
</div>
